import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useNavigate, useSearchParams } from "react-router-dom";
import liff from '@line/liff';
import CoreAPI from "../../../services/core";
import IconSurvey from "../../../assets/images/icon-survey.svg";
import IconSAT from "../../../assets/images/icon-sat.svg";
import IconLine from "../../../assets/images/icon-line.svg";
import ButtonComponent from "../../../components/button";
import InputComponent from "../../../components/evaluation-form-components/input";
import { onLoginLineLiff } from "../../../utils/default";
import { useLineDetail, useWebBackOfficeLineLoginSuccess } from "../../../contexts";
import LandingPage from "../../../components/landing-page";
import IconCheck from "../../../assets/images/icon-check.svg"

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: #FFFFFF;
    
    .main-box {
        width: calc(100% - 200px);
        height: calc(100% - 200px);
        display: flex;
        padding: 100px;
        transition: all 0.3s ease;
    }

    .box-image {
        width: calc(50% - 50px);
        height: 100%;
        margin-right: 100px;
        position: relative;
        background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
        border-radius: 16px;
        transition: all 0.3s ease;

        .label {
            color: #25368D;
            font-size: 26.87px;
            font-weight: 400;
            line-height: 40.18px;
            text-align: center;
            margin-top: 16px;
        }

        .img-logo {
            position: absolute;
            top: 16px;
            left: 16px;
            width: 125px;
        }

        .img-survey {
            width: 500px;
            transition: all 0.3s ease;
        }
    }

    .box-login {
        width: calc(50% - 50px);
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 36px;
        transition: all 0.3s ease;

        .label-header-login {
            color: #25368D;
            font-size: 30px;
            font-weight: 600;
            line-height: 44.85px;
            text-align: left;

            .sub {
                color: #505050;
                font-size: 15px;
                font-weight: 400;
                line-height: 22.43px;
                text-align: left;
            }
        }

        .label-mode {
            width: 160px;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
        }

        .line-mode {
            width: calc(50% - 80px);
            height: 1px;
            background-color: #313131;
            opacity: 0.25;
        }
    }

    @media screen and (max-width: 1500px) {
        .box-image {
            .img-survey {
                width: 400px;
            }
        }
    }

    @media screen and (max-width: 1200px) {
        .box-image {
            display: none;
        }

        .box-login {
            width: 100%;
            height: 100%;
        }
    }

    @media screen and (max-width: 700px) {
        .main-box {
            width: calc(100% - 48px);
            height: calc(100% - 48px);
            padding: 24px;
        }

        .box-image {
            display: none;
        }

        .box-login {
            width: 100%;
            height: 100%;
        }
    }
`;

const ButtonLine = styled.div`
    width: 100%;
    height: 56px;
    border: 1px solid #00CB42;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 1px 1px 15px #00CB4233;
    }
`;

const RememberBox = styled.div`
    height: 48px;
    min-height: 48px;
    color: #505050;
    font-size: 15px;
    font-weight: 400;
    line-height: 22.43px;
    text-align: left;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;

    &.active {
        color: #25368D;
    }

    .box {
        width: 16px;
        height: 16px;
        min-width: 16px;
        margin-left: 1px;
        margin-right: 12px;
        border-radius: 2px;
        border: 1px solid #505050;

        &.active {
            background-color:  #FBE250;
            border: 1px solid #FBE250;
        }
    }
`;

function LoginPage() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { webBackOfficeLineLoginSuccess, setWebBackOfficeLineLoginSuccess } = useWebBackOfficeLineLoginSuccess();
    const { lineDetail } = useLineDetail();
    const [isError, setIsError] = useState(false);
    const [loginDetail, setLoginDetail] = useState({
        username: "",
        password: "",
        remember: false,
    })
    const [isMapUser, setIsMapUser] = useState(false);
    const [lineLoginDetail, setLineLoginDetail] = useState(null)
    const [isLanding, setIsLanding] = useState(true);

    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLanding(true)
        const state = searchParams.get("state") || localStorage.getItem("state");
        const at = localStorage.getItem("at");
        if (at) {
            const profile = await onGetProfile();
            if (profile) {
                if (profile.user_department_id || profile.user_division_id) {
                    navigate(`/account`);
                } else {
                    navigate(`/user-management/list-view`);
                }
            }
        } else if (state === 'line_login') {
            if (webBackOfficeLineLoginSuccess) {
                setWebBackOfficeLineLoginSuccess(false);
                localStorage.removeItem("state");
                setLineLoginDetail(lineDetail)
                await onLoginByLine(lineDetail)
            }
        }
        setIsLanding(false)
    }
    async function onCheckLineLiffAdmin() {
        localStorage.setItem("state", 'line_login');
        const response = await onLoginLineLiff();
        if (response) {
            localStorage.removeItem("state");
            setLineLoginDetail(response)
            await onLoginByLine(response)
        }
    }
    async function onLoginByLine(param) {
        let response = null;
        try {
            const body = {
                line_access_token: param.token,
                line_user_id: param.profile?.userId,
                line_liff_id: param.liffId,
            }
            response = await CoreAPI.authenHttpService.LoginByLine(body)
        } catch { }
        if (response) {
            if (response.status === "map_user") {
                setIsMapUser(true)
            } else if (response.status === "success") {
                localStorage.setItem("at", response.access_token)
                localStorage.setItem("rt", response.refresh_token)
                const profile = await onGetProfile();
                if (profile) {
                    if (profile.user_department_id || profile.user_division_id) {
                        navigate(`/account`);
                    } else {
                        navigate(`/user-management/list-view`);
                    }
                }
            } else {
                setIsError(true)
            }
        } else {
            setIsError(true)
        }
    }
    async function onLogin() {
        let response = null;
        try {
            const body = {
                username: loginDetail.username,
                password: loginDetail.password,
                remember: loginDetail.remember,
            }
            response = await CoreAPI.authenHttpService.Login(body)
        } catch { }
        if (response) {
            if (response.status === "success") {
                localStorage.setItem("at", response.access_token)
                localStorage.setItem("rt", response.refresh_token)
                const profile = await onGetProfile();
                if (profile) {
                    if (profile.user_department_id || profile.user_division_id) {
                        navigate(`/account`);
                    } else {
                        navigate(`/user-management/list-view`);
                    }
                }
            } else {
                setIsError(true)
            }
        } else {
            setIsError(true)
        }
    }
    async function onMapUserAndLogin() {
        let response = null;
        try {
            const body = {
                username: loginDetail?.username,
                password: loginDetail?.password,
                line_user_id: lineLoginDetail?.profile?.userId,
            }
            response = await CoreAPI.authenHttpService.mapUserLineAndLogin(body)
        } catch { }
        if (response) {
            if (response.status === "success") {
                localStorage.setItem("at", response.access_token)
                localStorage.setItem("rt", response.refresh_token)
                const profile = await onGetProfile();
                if (profile) {
                    if (profile.user_department_id || profile.user_division_id) {
                        navigate(`/account`);
                    } else {
                        navigate(`/user-management/list-view`);
                    }
                }
            } else {
                setIsError(true)
            }
        } else {
            setIsError(true)
        }
    }
    async function onGetProfile() {
        let response = null;
        try {
            response = await CoreAPI.authenHttpService.getProfile();
        } catch { }
        if (response) {
            localStorage.setItem("profile", JSON.stringify(response));
        }
        return response
    }

    async function handleClickLineLogin() {
        await onCheckLineLiffAdmin();
    }
    async function handleClickLogin() {
        await onLogin();
    }
    async function handleClickMapUserAndLogin() {
        await onMapUserAndLogin();
    }
    async function handleClickBack() {
        setLoginDetail({
            username: "",
            password: "",
        })
        setIsMapUser(false)
        setIsError(false)
    }
    async function handleChangeLoginDetail(param, key) {
        let detail = { ...loginDetail };
        detail[key] = param;
        setLoginDetail(detail)
        setIsError(false)
    }
    async function handleEnterLogin(params) {
        if (!loginDetail.username || !loginDetail.password) return;
        await handleClickLogin();
    }
    async function handleEnterMapUser(params) {
        if (!loginDetail.username || !loginDetail.password) return;
        await handleClickMapUserAndLogin();
    }

    return (
        <Container>
            {isLanding && <LandingPage />}
            <div className="main-box">
                <div className="box-image content-center">
                    <img className="img-logo" alt="img" src={IconSAT} />
                    <div>
                        <img className="img-survey" alt="img" src={IconSurvey} />
                        <div className="label">ระบบเก็บข้อมูลจำนวนผู้ใช้บริการ<br />และแบบสอบถามประเมินความพึงพอใจ<br />การกีฬาแห่งประเทศไทย </div>
                    </div>
                </div>

                {!isMapUser &&
                    <div className="box-login horizontal-center">
                        <div className="label-header-login">
                            เข้าสู่ระบบ
                        </div>

                        <div style={{ width: "100%" }}>
                            <InputComponent
                                label={"Username"}
                                placeholder={"Username"}
                                value={loginDetail.username}
                                onInput={(e) => handleChangeLoginDetail(e, "username")}
                                onEnter={handleEnterLogin}
                                isError={isError}
                                labelError={"Username หรือ Password ไม่ถูกต้อง"}
                            />
                        </div>
                        <div style={{ width: "100%", marginTop: "-24px" }}>
                            <InputComponent
                                label={"Password"}
                                placeholder={"Password"}
                                value={loginDetail.password}
                                styleContainer={{ marginBottom: '0px' }}
                                type={"password"}
                                onInput={(e) => handleChangeLoginDetail(e, "password")}
                                onEnter={handleEnterLogin}
                                isError={isError}
                                labelError={"Username หรือ Password ไม่ถูกต้อง"}
                            />
                            <RememberBox className={`${loginDetail.remember ? "active" : ""} vertical-center`}
                                onClick={(e) => { handleChangeLoginDetail(!loginDetail.remember, 'remember') }}>
                                <div className={`content-center box ${loginDetail.remember ? "active" : ""}`}>
                                    {loginDetail.remember && <img alt="img" src={IconCheck} />}
                                </div>
                                Remember me
                            </RememberBox>
                        </div>
                        <div style={{ width: "100%" }}>
                            <ButtonComponent
                                label={"เข้าสู่ระบบ"}
                                variant={"primary"}
                                sceenSize={"lg"}
                                style={{ maxWidth: "100%" }}
                                disable={!loginDetail.username || !loginDetail.password}
                                onClick={handleClickLogin}
                            />
                        </div>

                        <div className="vertical-center" style={{ width: "100%" }}>
                            <div className="line-mode"></div>
                            <div className="label-mode horizontal-center">หรือลงชื่อเข้าใช้ด้วยไลน์</div>
                            <div className="line-mode"></div>
                        </div>
                        <div style={{ width: "100%" }}>
                            <ButtonLine className="content-center" onClick={handleClickLineLogin}>
                                <img alt="img" src={IconLine} />
                            </ButtonLine>
                        </div>
                    </div>
                }

                {isMapUser &&
                    <div className="box-login horizontal-center">
                        <div className="label-header-login">
                            ยืนยันการเข้าสู่ระบบด้วย LINE
                            <div className="sub" style={{ width: "100%" }}>
                                กรุณาเข้าสู่ระบบด้วย Username และ Password เพื่อเชื่อมบัญชีกับ Line
                            </div>
                        </div>


                        <div style={{ width: "100%" }}>
                            <InputComponent
                                label={"Username"}
                                placeholder={"Username"}
                                value={""}
                                onInput={(e) => handleChangeLoginDetail(e, "username")}
                                onEnter={handleEnterMapUser}
                                isError={isError}
                                labelError={"Username หรือ Password ไม่ถูกต้อง"}
                            />
                        </div>
                        <div style={{ width: "100%", marginTop: "-24px" }}>
                            <InputComponent
                                label={"Password"}
                                placeholder={"Password"}
                                value={""}
                                type={"password"}
                                onInput={(e) => handleChangeLoginDetail(e, "password")}
                                onEnter={handleEnterMapUser}
                                isError={isError}
                                labelError={"Username หรือ Password ไม่ถูกต้อง"}
                            />
                        </div>

                        <div style={{ width: "100%" }}>
                            <ButtonComponent
                                label={"เข้าสู่ระบบ"}
                                variant={"primary"}
                                sceenSize={"lg"}
                                style={{ maxWidth: "100%" }}
                                disable={!loginDetail.username}
                                onClick={handleClickMapUserAndLogin}
                            />
                        </div>

                        <div style={{ width: "100%" }}>
                            <ButtonComponent
                                label={"ย้อนกลับ"}
                                variant={"secondary"}
                                sceenSize={"lg"}
                                style={{ maxWidth: "100%" }}
                                onClick={handleClickBack}
                            />
                        </div>
                    </div>
                }

            </div>
        </Container>
    )
}

export default LoginPage;